/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Flex } from '@chakra-ui/react';
import Link from 'next/link';
import { Title } from '../PostSidebarStyled';
import {
  InnerContainer,
  RecentPostDate,
  RecentPostText,
} from './SidebarFeaturedStyled';
import { ISidebarFeaturedProps } from './interfaces';
import formattedDate from '@helpers/formattedDate';
import SanityImage from '@components/Shared/SanityImage';

const SidebarFeatured: React.FC<ISidebarFeaturedProps> = ({ posts }) => {
  return (
    <Flex direction="column" mt={6}>
      <Title>FEATURED POSTS</Title>
      {posts?.map((featuredPost) => (
        <Link
          key={featuredPost?._id ?? ''}
          href={`/blog/${featuredPost?.slug?.current}`}
          passHref
        >
          <InnerContainer className="mb-3">
            <Flex mr={4} w="70px" h="70px">
              <SanityImage
                sanityImage={featuredPost?.mainPhoto}
                alt="featured-posts"
                layout="fixed"
                width={70}
                height={70}
              />
            </Flex>
            <Flex direction="column">
              <RecentPostText>{featuredPost?.title}</RecentPostText>
              <RecentPostDate>
                {formattedDate(featuredPost?.date)}
              </RecentPostDate>
            </Flex>
          </InnerContainer>
        </Link>
      ))}
    </Flex>
  );
};

export default SidebarFeatured;
